const config = require('../../../../../config/locales_json/packs/private/users/profile.json');
const isosById = require('./isos.json');
const language = $('body').data("language");
const CHILE_COUNTRY_ID = "43";
const CHILE_ISO = "CL";
const AUTH_TOKEN = $('meta[name=csrf-token]').attr('content'); 

$(document).ready(function() {
  var $profileCountryStudy = $('#form_profile_country_study');

  initSelectize();
  setDynamicActions();
  listenDynamicActions();

  function initSelectize() {
    const selectizeInputs = $("form .selectize");
    selectizeInputs.each(function() {
      const $this = $(this);
      let selectizeOptions = { create: false }
      if (!$this.hasClass('country')) selectizeOptions.sortField = 'text';
      $this.selectize(selectizeOptions);
    });
  }

  function setDynamicActions(){
    $("form .dynamic_action_field").each(function(e) {
      handleDynamicQuestion($(this))
    });

    // Crea una instancia de MutationObserver y pasa una función callback
    const observer = new MutationObserver(function(mutations) {
      mutations.forEach(function(mutation) {
        if (mutation.type === "childList") {
          $(mutation.addedNodes).each(function() {
            if (this.nodeType === 1 && $(this).find('.dynamic_action_field').length > 0) { // Verifica si es un elemento y tiene la clase 'dynamic_field'
              $(this).find('.dynamic_action_field').each(function() {
                // Verifica si el elemento actual es un input de tipo radio
                if ($(this).is('input[type="radio"]') && $(this).is(':checked')) {
                  handleDynamicQuestion($(this))
                } else if($(this).is('select')) {
                  handleDynamicQuestion($(this))
                }
              });
            } else if (this.nodeType === 1 && $(this).find('#form_profile_document_type').length > 0) {
              $('#form_profile_document_type').on("change", function(){
                var selectDoc = $(this);
                setMaskDocumentId();
              });
              setMaskDocumentId();
            } else if (this.nodeType === 1 && $(this).find('#form_profile_university').length > 0) {
              var  countryStudyId = $profileCountryStudy.val();
              if (countryStudyId != "") {
                var profileUniversity = $('#form_profile_university');
                loadUniversities(profileUniversity, countryStudyId);
              }
            } else if (this.nodeType === 1 && $(this).find('#form_profile_career').length > 0) {
              var  countryStudyId = $profileCountryStudy.val();
              if (countryStudyId != "") {
                var profileCareer = $('#form_profile_career');
                loadCareers(profileCareer, countryStudyId);
              }
            }
          });
        }
      });
    });

    // Especifica qué cambios en el DOM observar
    const config = { attributes: false, childList: true, subtree: true };

    // Comienza a observar el documento completo para los cambios configurados
    observer.observe(document.body, config);
  }

  function listenDynamicActions(){
    $("form").on("change", ".dynamic_action_field", function(e) {
      handleDynamicQuestion($(this))
    });
  }

  function handleDynamicQuestion(input){
    const fieldName = $(input).attr("name");
    const inputValue = $(input).val();

    if(fieldName && inputValue){
      const questionID = getQuestionIDFromInputName(fieldName);

      if(questionID){      
        let submitBtn = $("#profile-form .card-toolbar button.btn");
        if (submitBtn.length == 0) submitBtn = $("#profile-form .card-toolbar a.btn");
        if (submitBtn.length > 0) submitBtn.addClass("disabled");

        $.ajax({
          type: "POST",
          url: '/usuario/perfil/handle_dynamic_fields',
          dataType: 'script',
          data: {
            question_id: questionID,
            value: inputValue,
            form_values: getFormData(),
            authenticity_token: AUTH_TOKEN
          },
          success: function(response) {
            if (submitBtn.length > 0) submitBtn.removeClass("disabled");
          },
          error: function(response) {
            console.error("Error al cargar las preguntas condicionadas")
            if (submitBtn.length > 0) submitBtn.removeClass("disabled");
          }
        });
      }
    }
  }

  function getFormData(){
    // Objeto para almacenar los IDs y sus valores
    var formData = {};

    // Selecciona todos los inputs y selects dentro del formulario
    $('form input, form select').each(function() {
      // $(this) se refiere al elemento actual en el bucle
      const idInput = $(this).attr('id'); // Obtiene el ID del elemento
      const valueInput = $(this).val(); // Obtiene el valor del elemento
      
      // Almacena el ID y su valor en el objeto
      if(idInput && valueInput){
        formData[idInput] = valueInput;
      }
    });

    return formData;
  }

  function getQuestionIDFromInputName(inputName){
    const resultado = inputName.match(/\[(.*?)\]/);
    return resultado ? resultado[1] : null;
  }

  function cleanStudySelectize(input) {
    var selectize = input[0].selectize
    selectize.clear()
    selectize.clearOptions()
    selectize.disable()
  }

  // Buscamos las universidades según el país
  function loadUniversities(input, countryID){
    var inputValue = input.val();
    
    $.ajax({
      url: '/settings/universities/' + countryID,
      type: 'GET',
      dataType: 'json',
      success: function(results) {
        if(results.data.length > 0){
          cleanStudySelectize(input);

          const containerFieldTo = input.parent().parent();

          // Rellenando los selects
          input.removeAttr("disabled")
          input.removeClass("optional")
          profileUniversity = input[0].selectize;
          profileUniversity.enable();
          profileUniversity.clear();
          profileUniversity.clearOptions();
          $.each(results.data, function(index, value) {
            profileUniversity.addOption({value: value['id'], text: value['name'] });
          });
          
          if (inputValue) input[0].selectize.setValue(inputValue);

          containerFieldTo.removeClass("hidden").removeClass("optional");

        } else {
          console.error('No se encontraron universidades asociadas al país seleccionado')
        }
      },
      error: function (request, status, error) {
        console.error('Error al cargar dinámicamente las universidades')
      }
    });
  }

  // Buscamos las carreras según el país
  function loadCareers(input, countryID){
    var inputValue = input.val();

    $.ajax({
      url: '/settings/careers_country/' + countryID,
      type: 'GET',
      dataType: 'json',
      success: function(results) {
        if(results.data.length > 0){
          cleanStudySelectize(input);

          const containerFieldTo = input.parent().parent();

          // Rellenando los selects
          input.removeAttr("disabled")
          input.removeClass("optional")
          profileCareer = input[0].selectize;
          profileCareer.enable();
          profileCareer.clear();
          profileCareer.clearOptions();
          $.each(results.data, function(index, value) {
            profileCareer.addOption({value: value['id'], text: value['name'] });
          });

          if (inputValue) input[0].selectize.setValue(inputValue);

          containerFieldTo.removeClass("hidden").removeClass("optional");

        } else {
          console.error('No se encontraron carreras asociadas al país seleccionado')
        }
      },
      error: function (request, status, error) {
        console.error('Error al cargar dinámicamente las carreras')
      }
    });
  }


  /*************
  * Envío de formulario
  *
  * Detiene la ejecucion del formulario
  * si no hay errores lo envía, de lo contrario muestra los mensajes de error.
  *
  */
  $("#profile-form .save-button").on("click", function(e){
    e.preventDefault();

    var form = check_inputs_form();

    if(!form){
      return false;
    } else {
      const successText = getTranslationValue(config, [language, "success_text"],"Guardando información...");
      $("#profile-form").addClass("disabled")
      $(this).text(successText)
      $("#profile-form").submit();
    }
  });

  function check_inputs_form(){
    var error = 0;
    var container = $('#profile-form .card-body');
    var inputs = container.find($("input").not(".optional"));
    var selects = container.find($("select").not(".optional"));
    const errorText = getTranslationValue(config, [language, "check_inputs_error_text"],"Debes completar este campo");
  
    inputs.each(function() {
      var inputName = $(this).attr('name');
      var inputType = $(this).attr('type');
      var contInput = $(this).parent().parent();
      contInput.find('.err-msg').remove();
  
      if(inputName != null && inputName != "") {
        if (inputType == "radio" || inputType == "checkbox") {
          inputName = $(this).attr('name');
          var isChecked = $('input[name="'+ inputName +'"]:checked').length;
  
          contInput = $(this).parent().parent().parent();
          contInput.find('.err-msg').remove();
  
          if (isChecked == 0) {
            contInput.append('<div class="col-lg-3 col-xl-3 col-form-label err-msg"></div><div class="col-lg-9 col-xl-9 err-msg"><div class="alert alert-custom alert-outline-danger" role="alert"><div class="alert-icon"><i class="flaticon-warning"></i></div><div class="alert-text">'+errorText+'</div></div></div></div>');
            error++;
          }
        } else if (inputType == "text" || inputType == "number" || inputType == "hidden") {
          contInput.find('.err-msg').remove();
  
          if (!$(this).val()) {
            contInput.append('<div class="col-lg-3 col-xl-3 col-form-label err-msg"></div><div class="col-lg-9 col-xl-9 err-msg"><div class="alert alert-custom alert-outline-danger" role="alert"><div class="alert-icon"><i class="flaticon-warning"></i></div><div class="alert-text">'+errorText+'</div></div></div></div>');
  
            error++;
          }
        }
      }
    })
  
    selects.each(function() {
      var inputName = $(this).attr('name');
      var contInput = $(this).parent().parent();
      contInput.find('.err-msg').remove();
  
      if(inputName != null && inputName != "") {
        if (!$(this).val()) {
          contInput.append('<div class="col-lg-3 col-xl-3 col-form-label err-msg"></div><div class="col-lg-9 col-xl-9 err-msg"><div class="alert alert-custom alert-outline-danger" role="alert"><div class="alert-icon"><i class="flaticon-warning"></i></div><div class="alert-text">'+errorText+'</div></div></div></div>');
          error++;
        }
      }
    })

    // Validación de inputs opcionales que tengan validación especial
    var specialValidationInputs = container.find("input[data-validation-type].optional");
    specialValidationInputs.each(function () {
      var contInput = $(this).parent().parent();
      contInput.find('.err-msg').remove();

      var errorMsg = validateSpecialInputs(this);
      if (errorMsg != "") {
        contInput.append('<div class="col-lg-3 col-xl-3 col-form-label err-msg"></div><div class="col-lg-9 col-xl-9 err-msg"><div class="alert alert-custom alert-outline-danger" role="alert"><div class="alert-icon"><i class="flaticon-warning"></i></div><div class="alert-text">'+errorMsg+'</div></div></div></div>');

        error++;
      }
    })
  
    return error == 0 ? true : false;
  }

  /*************
  * Mascaras para los field inputs
  *
  */
  var profileCountry = $('#form_profile_co')
  const inputPhone = document.querySelector("#form_profile_phone");

  if ($("#form_profile_phone").length > 0){
    intlTelInput(inputPhone, {
      initialCountry: "CL",
      preferredCountries: ["CL", "PE", "AR", "CO", "EC", "MX", "VE", "BO", "PA", "GT", "CR", "ES", "SV", "UY", "DO", "HN", "PY", "NI", "BR", "US"],
      autoHideDialCode: false,
      nationalMode: false
    });

    $('#form_profile_phone').on('focus', function(){
      var $this = $(this),
          // Get active country's phone number format from input placeholder attribute
          activePlaceholder = $this.attr('data-maskara'),
          // Convert placeholder as exploitable mask by replacing all 1-9 numbers with 0s
          newMask = activePlaceholder.replace(/[1-9]/g, "0");

      // Init new mask for focused input
      $this.mask(newMask);
    });
  }

  if (profileCountry.length > 0){
    profileCountry.on("change", function () {
      const residenceCountryValue = profileCountry.val();
      const phoneInput = $("#form_profile_phone")

      try {
        const oldDialCode = intlTelInput(inputPhone).getSelectedCountryData()['dialCode'];

        if (phoneInput.length > 0 && residenceCountryValue.length > 0 && phoneInput.val() == '+'+oldDialCode){
          const selectedIso = getIsoByCountryId(residenceCountryValue);
          intlTelInput(inputPhone).setCountry(selectedIso);
          const selectedCountryDialCode = intlTelInput(inputPhone).getSelectedCountryData()['dialCode'];
          
          if (!selectedCountryDialCode) return;
          
          intlTelInput(inputPhone).setNumber('+' + selectedCountryDialCode); 
        }
      } catch (error) {
        console.error(error)
      }
  })
  }

  $('#profile-form').on("change", '#form_profile_nationality', function(){
    var selectDoc = $(this);
    setMaskDocumentId();
  });

  setMaskDocumentId();


  /*************
  * Calendario para la fecha de nacimiento
  *
  */
  $('#form_profile_birthdate').datepicker({
    todayBtn: "linked",
    endDate: '-17y',
    language: 'es',
    format: 'yyyy-mm-dd',
    clearBtn: true,
    templates: {
        leftArrow: '<i class=\"la la-angle-left\"></i>',
        rightArrow: '<i class=\"la la-angle-right\"></i>'
    }
  }).on('hide', function(event){
    var dateText = event.target.value; // Obtener el valor del campo de fecha
    var selectedDate = new Date(dateText);
    
    if (!isValidDate(selectedDate)) {
      alert('La fecha ingresada no es válida. Por favor, seleccione una fecha válida.');
      $('#form_profile_birthdate').val('');
    }
  });

  function setMaskDocumentId(){
    if ($('#form_profile_document_type').val() == "1" && $('#form_profile_nationality').val() == CHILE_COUNTRY_ID){
      $('input#form_profile_document_id').mask('MZ.ZZZ.ZZZ-K',{translation:  {
          'M': {pattern: /[0-9]/, optional: true},
          'Z': {pattern: /[0-9]/},
          'K': {pattern: /[0-9Kk]/},
        },
        reverse: true
      });
    }else{
      $('input#form_profile_document_id').unmask();
    }
  }

  function isValidDate(date) {
    var minDate = new Date('1950-01-01');
    var maxDate = new Date('2010-12-31');
    return date >= minDate && date <= maxDate;
  }

  function getTranslationValue(config, keys, defaultValue) {
    if (keys.length <= 1) return defaultValue;
    
    let currentTranslation;
    let firstIteration = true;
    
    for (let key of keys) {
  
      if (firstIteration) {
  
        if (config[key]) {
          currentTranslation = config[key];
          firstIteration = false;
        } else {
          firstIteration = false;
          return defaultValue;
        }
      } else {
        
        if (currentTranslation[key]) {
          currentTranslation = currentTranslation[key];
        } else {
          return defaultValue;
        }
      }
    }
    
    return currentTranslation;
  }
  
  function getIsoByCountryId(id){
    if (!isosById || !isosById["isos"]) return CHILE_ISO;
    
    const filterIsos = isosById["isos"].filter(function(iso){return iso.id == id;});
    if (filterIsos.length === 0 || !filterIsos[0] || !filterIsos[0].iso) return CHILE_ISO;
  
    return filterIsos[0].iso;
  }

  function validateSpecialInputs(input) {
    const specialValidationType = $(input).data('validation-type');
    const inputValue = $(input).val().trim();

    if (!inputValue || !specialValidationType) return "";

    const locale = $('body').data("language");
    const urlRegex = /^(https?|http?):\/\/[^\s/$.?#].[^\s]*$/
    const emailRegex = /\b[\w+\-.]+@[a-z\d\-.]+\.[a-z]+\b/

    if (specialValidationType == "url" && !urlRegex.test(inputValue)) {
      const errorMsg = { "es": "Debe ingresar una url valida", "en": "You must enter a valid URL.", "pt": "Você deve inserir uma URL válida" };
      return errorMsg[locale] || "Debe ingresar una url valida";

    } else if (specialValidationType == "email" && !emailRegex.test(inputValue)) {
      const errorMsg = { "es": "Debe ingresar un email valido", "en": "You must enter a valid email", "pt": "Você deve inserir um e-mail válido" };
      return errorMsg[locale] || "Debe ingresar un email valido";

    } else {
      return "";
    }
  }
});